import React from 'react'

// 公共Context，用于获取全局数据，如：语言、多语言数据等
export const CommonContext = React.createContext({
  // 语言
  locale: '',
  // 多语言数据
  __: {},
})

export default () => React.useContext(CommonContext)
